<template>
	<!--地图容器-->
	<div id="con"></div>
</template>
 
<script>
import AMapLoader from '@amap/amap-jsapi-loader'; //引入
import {mapState} from 'vuex'
  export default {
    name: "gaode",
	data() {
      return {
        map: null ,//初始化 map 对象
		infoWindow: null,
      }
    },
	computed:{
		...mapState({
			contact: state => state.contact
		})
	},
	methods: {
		initMap() {
			AMapLoader.load({
			  key: "5afea731bd7ba34bdc67e24309eacedd", //此处填入我们注册账号后获取的Key
			  version: "2.0", //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
			  plugins: [''], //需要使用的的插件列表，如比例尺'AMap.Scale'等
			}).then((AMap) => {
			  this.map = new AMap.Map("con", {
			      resizeEnable: true,
			      center: [116.630941, 39.942776],
			      zoom: 14
			  });
			  
			  var marker = new AMap.Marker({
			    position: this.map.getCenter(),
			    offset: new AMap.Pixel(0, 0)
			  });
			  marker.setTitle('中翔钢铁集团')
			  
			  marker.setLabel({
				  offset: new AMap.Pixel(-240, -40),  //设置文本标注偏移量
				  content: "<div>" + 
				  "<div>电话："+this.contact.phone1+"</div>" +
				  "<div style='white-space:pre-line'>地址："+this.contact.address+"</div>" +
				  "</div>", //设置文本标注内容
			  })
			  
			  this.map.add(marker)
			}).catch(e => {
			  console.log(e);
			})
		  },
	},
	mounted() {
		//挂载阶段调用，DOM初始化完成进行地图初始化
		this.initMap();
	},
	
}
</script>
 
<style scoped>
 #con {
    width: 99%;
    height: 400px;
    border: 1px solid red;
  }

</style>